import { Component } from '@angular/core';

interface USPItem {
    id: number;
    icon: string;
    title: string;
    description: string;
}

@Component({
    selector: 'app-usp-section',
    templateUrl: './usp-section.component.html',
    styleUrls: ['./usp-section.component.scss']
})
export class UspSectionComponent {
    sectionTitle = 'WHY CHOOSE US';

    uspItems: USPItem[] = [
        {
            id: 1,
            icon: 'verified',
            title: 'ISO-Certified OEM Manufacturer',
            description: '100% in-house design, testing & quality control.'
        },
        {
            id: 2,
            icon: 'local_shipping',
            title: 'PAN India Delivery & Support',
            description: 'Fast installation + dedicated support team.'
        },
        {
            id: 3,
            icon: 'attach_money',
            title: 'Best Institutional Pricing',
            description: 'Value-driven packages for schools & govt projects.'
        },
        {
            id: 4,
            icon: 'school',
            title: '10,000+ Classrooms Digitization',
            description: 'Trusted by schools, coaching centres & corporates.'
        },
        {
            id: 5,
            icon: 'support_agent',
            title: '24/7 Support',
            description: 'Dedicated academic & technical helpdesk.'
        },
        {
            id: 6,
            icon: 'factory',
            title: 'State-of-the-art manufacturing facilities',
            description: 'ISO-certified OEM manufacturer.'
        }
    ];
}